// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce4a6241","239":"efc00ce9","455":"4ce23aac"}[chunkId] + ".chunk.js";
};